/* eslint-disable @typescript-eslint/no-explicit-any */
import * as yup from 'yup'

import { OptionProps, STATUS } from 'types'
import { ProductCategoryService } from '.'

import { IProductCategoryFormProps } from 'features/ProductCategory'

type Context = yup.TestContext & { type?: string }

export type queryParamProps = {
  q: string
  _page: number
  _ids: number[]
  _sort: 'ASC' | 'DESC'
  _order: string
  isActive: string
}

export const getQueryParams = (path: string): queryParamProps => {
  const urlParams = new URLSearchParams(path)
  const whitelist = ['q', '_page', '_ids', '_sort', '_order', 'isActive']

  const queryParams: any[] = []

  whitelist.forEach((item) => {
    queryParams.push(urlParams.get(item))
  })

  const [q, page, ids, sort, order, isActive] = queryParams
  const newIds =
    typeof ids === 'string' && ids ? ids.split(',').map((id) => Number(id)) : []

  return {
    q: q || '',
    _page: Number(page) || 1,
    _ids: newIds,
    _sort: sort || '',
    _order: order || 'ASC',
    isActive: isActive || '',
  }
}

export const generateUrl = (_params: any = {}, _update: any = {}): string => {
  const updateQuery = { ..._params, ..._update }

  return `?${new URLSearchParams(updateQuery).toString()}`
}

export const schemaProductCategoryForm = yup.object().shape({
  name: yup
    .string()
    .max(30)
    .required('productCategory:name.required')
    .test('name', async (name, context: Context) => {
      const { path, resolve, createError, parent, type } = context

      if (!name) {
        return resolve(true)
      }

      if (
        parent?.currentState === type ||
        parent?.currentState === 'onSubmit'
      ) {
        const pathname = window.location.pathname
        const matchedProductCategoryId = pathname.match(
          new RegExp(/product-category\/(.*?)\/edit/),
        )

        const productCategoryId =
          matchedProductCategoryId && matchedProductCategoryId[1]

        const response = await ProductCategoryService.findAll({
          nameTh: name.trim(),
          isActive: STATUS.ALL,
          _limit: 0,
        })
        const productCategory = response?.body.find(
          (_productCategory) =>
            _productCategory.name.toLowerCase() === name.trim().toLowerCase(),
        )

        if (!productCategory) {
          return resolve(true)
        }

        if (productCategoryId === `${productCategory.id}`) {
          return resolve(true)
        }

        return createError({
          path,
          message: 'productCategory:name.duplicate',
        })
      }

      return false
    }),
  detail: yup.string(),
  isActive: yup.boolean(),
})

export const initialProductCategoryForm: IProductCategoryFormProps = {
  currentState: 'name',
  name: '',
  detail: '',
  isActive: true,
}

export const findSelected = (
  options?: OptionProps[] | null,
  key?: string,
): OptionProps | null | undefined => {
  if (!options) {
    return null
  }

  return options.find((item: OptionProps) => item.key === key)
}
